import React from 'react';
import Suspense from '../../Suspense';
import Router from './Components/Router';
import StyledBox from './styles';

const SearchPage = React.lazy(() => import('./Components/SearchPage'));

interface MainWindowProps {
  setRef: React.Dispatch<React.SetStateAction<HTMLDivElement>>
}

export default function MainWindow(props: MainWindowProps) {
  const { setRef } = props;

  return (
    <StyledBox ref={(r: HTMLDivElement) => { setRef(r); }} id="main-window">
      <Router />
      <Suspense><SearchPage /></Suspense>
    </StyledBox>
  );
}
